
import { Component, Vue, Watch } from "vue-property-decorator"
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import HelpComponent from "./help.vue";
import { CountdownInterface } from "../store/config.types";
import HeaderCountdownConfigEditComponent from "./header-countdown-config-edit.vue";
import { ICountdowns } from "../store-services/staticdata.types";

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)

@Component({
  components: {
    "help": HelpComponent,
    "countdown-edit-dialog": HeaderCountdownConfigEditComponent
  }
})
export default class HeaderCountdownConfigComponent extends Vue {
  contextHelp = "## Countdown menu\nYou can add countdowns to be shown in the header (up to three enabled at once). You can create your own countdowns or import predefined ones from a central server. If you want to pause (hold) a countdown you can just double-click on it in the header."
  show: boolean = false
  showCountdownEditDialog: boolean = false
  currentCountdownId: number = NaN

  get countdowns(): Array<CountdownInterface> {
    return (this.$store.getters["config/getCountdown"]() as Array<CountdownInterface>).filter(c => c.hasOwnProperty("title"))
  }

  get predefined_countdown_data(): ICountdowns {
    return this.$store.getters["staticdata/getCountdowns"]
  }
  get predefined_countdowns(): Array<{countdown: CountdownInterface, existing: number}> {
    return this.predefined_countdown_data.content?.data.countdowns.map(cp => {return {
      countdown: cp,
      existing: this.countdowns.findIndex(c => c.title === cp.title)
    }}) || []
  }

  get countdown(): CountdownInterface {
    if (this.currentCountdownId >= 0) {
      return this.countdowns[this.currentCountdownId]
    }
    return {
      enabled: true,
      title: "",
      description: "",
      remainingSeconds: 0
    }
  }

  formatTarget(countdown: CountdownInterface) {
    let value
    if (countdown.remainingSeconds !== undefined) {
      value = dayjs.duration(Math.abs(countdown.remainingSeconds || 0))
      return `remaining: ${(countdown.remainingSeconds || 0) <= 0 ? '-' : '+'}${(value.asDays() | 0).toFixed(0).padStart(3, "0")}:${value.format("HH:mm:ss")}`
    } else {
      value = dayjs.utc(countdown.timestamp)
      return `target: ${value.format("DD.MM.YYYY HH:mm:ss")}`
    }
  }

  saveCountdown(countdown: CountdownInterface) {
    let countdowns = this.countdowns
    if (!Number.isNaN(this.currentCountdownId)) {
      countdowns.splice(this.currentCountdownId, 1, countdown)
    } else {
      countdowns.push(countdown)
    }
    this.$store.dispatch("config/updateCountdowns", countdowns)
  }

  deleteCountdown() {
    let countdowns = this.countdowns
    countdowns.splice(this.currentCountdownId, 1)
    this.$store.dispatch("config/updateCountdowns", countdowns)
  }

  enableCountdown() {
    let countdowns = this.countdowns
    countdowns[this.currentCountdownId].enabled = !countdowns[this.currentCountdownId].enabled
    this.$store.dispatch("config/updateCountdowns", countdowns)
  }

  importPredefCountdown(id: number) {
    let countdowns = this.countdowns
    if (this.predefined_countdowns[id].existing >= 0) {
      countdowns.splice(this.predefined_countdowns[id].existing, 1, this.predefined_countdowns[id].countdown)
    } else {
      countdowns.push(this.predefined_countdowns[id].countdown)
    }
    this.$store.dispatch("config/updateCountdowns", countdowns)
  }

  close() {
    this.show = false
  }

  @Watch("show")
  showWatch(newValue: boolean) {
    if (newValue) {
      this.$store.dispatch("staticdata/updateCountdowns")
    }
  }
}
